"use strict";
/**
 * BudgetLine Model
 *
 * Represents a single budget line item within a Budget.
 * Each line maps to an accounting category and tracks budgeted vs actual amounts.
 *
 * All monetary values (budgetAmount, actualAmount) are stored as integer pence
 * to avoid floating-point errors. Display in pounds sterling: (pence || 0) / 100
 */
Object.defineProperty(exports, "__esModule", { value: true });
